var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('hide-panel-button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { ChevronRightIconGlyph } from '@shapeable/icons';
export var HIDE_PANEL_BUTTON_SIZE_BASE = 40;
export var HIDE_PANEL_BUTTON_SIZE = 54;
export var HidePanelButtonDefaultProps = {
  label: 'HIDE',
  isVertical: false,
  color: 'light',
  iconColor: 'light',
  hoverIconColor: 'light',
  backgroundColor: 'dark',
  hoverBackgroundColor: '#333',
  borderColor: '#333'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    font-family: ", ";\n    \n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    font-family: ", ";\n    \n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.FONT('sans'), function (_a) {
    var _backgroundColor = _a._backgroundColor,
      _hoverBackgroundColor = _a._hoverBackgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      &:hover {\n        background: ", ";\n      }\n\n    "], ["\n      background: ", ";\n      &:hover {\n        background: ", ";\n      }\n\n    "])), theme.COLOR(_backgroundColor), theme.COLOR(_hoverBackgroundColor));
  }, function (_a) {
    var isVertical = _a.isVertical,
      _borderColor = _a._borderColor;
    return !isVertical && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: 0 ", ";\n      border-bottom: 1px solid ", ";\n      flex-direction: row;\n      height: ", "px;\n      padding-bottom: 2px;\n    "], ["\n      padding: 0 ", ";\n      border-bottom: 1px solid ", ";\n      flex-direction: row;\n      height: ", "px;\n      padding-bottom: 2px;\n    "])), theme.UNIT(2), _borderColor, HIDE_PANEL_BUTTON_SIZE_BASE);
  }, function (_a) {
    var isVertical = _a.isVertical,
      _borderColor = _a._borderColor;
    return isVertical && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", " 0;\n      border-right: 1px solid ", ";\n      flex-direction: column;\n      width: ", "px;\n    "], ["\n      padding: ", " 0;\n      border-right: 1px solid ", ";\n      flex-direction: column;\n      width: ", "px;\n    "])), theme.UNIT(4), _borderColor, HIDE_PANEL_BUTTON_SIZE);
  })
});
var IconAndLabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  \n    ", "\n    \n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n  \n    ", "\n    \n    ", "\n  "])), function (_a) {
    var isVertical = _a.isVertical;
    return isVertical && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "])));
  }, function (_a) {
    var isVertical = _a.isVertical;
    return !isVertical && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      flex-direction: row;\n      padding-left: 3px;\n    "], ["\n      flex-direction: row;\n      padding-left: 3px;\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.FILL(_color));
  })
});
var ArrowIconStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.FILL(_color));
  })
});
var LabelContainerStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n\n    ", "\n\n"], ["\n    display: flex;\n    position: relative;\n\n    ", "\n\n"])), function (_a) {
    var isVertical = _a.isVertical;
    return isVertical && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      width: 20px;\n    "], ["\n      width: 20px;\n    "])));
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\n    ", "\n\n    margin-left: ", ";\n    font-size: ", ";\n    ", "\n  "], ["\n\n    ", "\n\n    margin-left: ", ";\n    font-size: ", ";\n    ", "\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(_color));
  }, theme.UNIT(2), theme.FONT_SIZE(13), function (_a) {
    var isVertical = _a.isVertical;
    return isVertical && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      transform-origin: 100% 0;\n      transform: rotate(90deg);\n      margin-left: 0;\n      width: 20px;\n      white-space: nowrap;\n      position: absolute;\n      top: 30px;\n      left: -2px;\n    "], ["\n      transform-origin: 100% 0;\n      transform: rotate(90deg);\n      margin-left: 0;\n      width: 20px;\n      white-space: nowrap;\n      position: absolute;\n      top: 30px;\n      left: -2px;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_17 || (templateObject_17 = __makeTemplateObject([""], [""]))),
  IconAndLabel: styled.span.attrs(cls.attr('icon-and-label'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconAndLabelStyles),
  Icon: styled(Icon)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  LabelContainer: styled.div.attrs(cls.attr('label-container'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LabelContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  ArrowIcon: styled(Icon)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ArrowIconStyles)
};
My.Container = styled.button(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  ", ";\n  \n  &:hover {\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  ", ";\n  \n  &:hover {\n    ", " {\n      ", "\n    }\n  }\n"])), ContainerStyles, My.ArrowIcon, function (_a) {
  var _hoverIconColor = _a._hoverIconColor;
  return css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n        ", ";\n      "], ["\n        ", ";\n      "])), theme.FILL(_hoverIconColor));
});
export var HidePanelButton = function (props) {
  var className = props.className,
    onClick = props.onClick,
    label = props.label,
    children = props.children,
    isVertical = props.isVertical,
    icon = props.icon,
    backgroundColor = props.backgroundColor,
    hoverBackgroundColor = props.hoverBackgroundColor,
    borderColor = props.borderColor,
    iconColor = props.iconColor,
    hoverIconColor = props.hoverIconColor,
    color = props.color;
  return React.createElement(My.Container, {
    _backgroundColor: backgroundColor,
    _hoverIconColor: hoverIconColor,
    _hoverBackgroundColor: hoverBackgroundColor,
    _borderColor: borderColor,
    isVertical: isVertical,
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.IconAndLabel, {
    isVertical: isVertical
  }, React.createElement(My.Icon, {
    _color: color,
    size: isVertical ? 32 : 24
  }, icon), React.createElement(My.LabelContainer, {
    isVertical: isVertical
  }, React.createElement(My.Label, {
    _color: color,
    isVertical: isVertical
  }, children || label))), React.createElement(My.ArrowIcon, {
    _color: iconColor,
    size: isVertical ? 24 : 18
  }, React.createElement(ChevronRightIconGlyph, null)));
};
HidePanelButton.defaultProps = HidePanelButtonDefaultProps;
HidePanelButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;